import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { baseurl, baseurImage } from "../../Baseurl";
import Swal from "sweetalert2";
import { FaPlus, FaSearch } from "react-icons/fa";
// import "./PatientServices.css";
import EventBus from "../../Context/EventBus";
import { useSelector, useDispatch } from "react-redux";
// import { useEffect, useState,  } from "react";
import logo from "../../assests/logo.png";
import axiosInstance from "../../api/axiosInstance";
import { triggerLabRefresh } from "../../store/labSlice";
import { checkForceConsents } from "../../utils/functions";
import QuickAddConsentModal from "./QuickAddConsentModal";

export default function PatientServices({ patientId, patientDetailsFromParent }) {
  const dispatch = useDispatch();
  const refreshKey = useSelector((state) => state.lab.refreshKey);
  const allBranchSettings = useSelector((state) => state.business.allBranchSettings);
  const isSingleBranch = !allBranchSettings || allBranchSettings.length <= 1;
  const [services, setServices] = useState([]);
  const [planTotal, setPlanTotal] = useState(0);
  const [completedTotal, setCompletedTotal] = useState(0);
  const [totalPlanServices, setTotalPlanServices] = useState(0);
  const [totalCompleteServices, setTotalCompleteServices] = useState(0);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [availableInventory, setAvailableInventory] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [serviceModalOpen, setServiceModalOpen] = useState(false);
  const [pendingMissingConsents, setPendingMissingConsents] = useState(null);
  const [inventoryModalOpen, setInventoryModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [searchServiceQuery, setSearchServiceQuery] = useState("");
  const [searchInventoryQuery, setSearchInventoryQuery] = useState("");
  const [showServiceSuggestions, setShowServiceSuggestions] = useState(false);
  const [showInventorySuggestions, setShowInventorySuggestions] =
    useState(false);
  const [hasActiveInsuranceCard, setHasActiveInsuranceCard] = useState(false);
  const [insuranceCompanyId, setInsuranceCompanyId] = useState(null);
  const [serviceTableSearchTerm, setServiceTableSearchTerm] = useState("");
  const [inventoryTableSearchTerm, setInventoryTableSearchTerm] = useState("");
  // State declarations
  // const [doctors, setDoctors] = useState([]);
  const [loggedInDoctor, setLoggedInDoctor] = useState(null);
  const [enhancedDoctors, setEnhancedDoctors] = useState([]);
  const [globalDiscountLimit, setGlobalDiscountLimit] = useState(0);

  // Pagination state
  const [currentServicePage, setCurrentServicePage] = useState(1);
  const [currentInventoryPage, setCurrentInventoryPage] = useState(1);
  const servicesPerPage = 10;
  const inventoryPerPage = 10;

  // Service form data
  const [serviceFormData, setServiceFormData] = useState({
    serviceId: "",
    extraNotes: "",
    discountType: "Amount", // "Amount" or "Percentage" (API expects capitalized)
    discountValue: 0,
    status: "Plan", // "Plan" or "Completed"
    customCost: "", // Custom cost that user can edit
    quantity: 1,
    sent_by: "",
  });

  // Inventory form data
  const [inventoryFormData, setInventoryFormData] = useState({
    inventoryId: "",
    quantity: 1,
  });

  const [printLoading, setPrintLoading] = useState(false);
  const [isSelectingForPrint, setIsSelectingForPrint] = useState(false);
  const [selectedPrintIds, setSelectedPrintIds] = useState([]);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [patientDetails, setPatientDetails] = useState(null);
  const [termsCondition, setTermsCondition] = useState(null);
  const [recordLockHours, setRecordLockHours] = useState(null);

  useEffect(() => {
    axiosInstance.get('getBusinessSettings')
      .then(res => {
        const h = res.data?.data?.record_lock_hours
        if (h != null) setRecordLockHours(Number(h))
      })
      .catch(() => {})
  }, [])

  // Fetch global discount limit - use same endpoint as FinanceSetting
  useEffect(() => {
    const fetchGlobalDiscountLimit = async () => {
      try {
        const response = await axiosInstance.get(`getAllDiscount`);
        const data = response.data?.data;
        const value = Array.isArray(data) && data.length > 0
          ? Number(data[0].discount_value)
          : Number(data?.discount_value);
        setGlobalDiscountLimit(Number.isFinite(value) ? value : 0);
      } catch (error) {
        console.error("Error fetching global discount:", error);
        setGlobalDiscountLimit(0);
      }
    };
    fetchGlobalDiscountLimit();
  }, [])

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axiosInstance.get("getTermsCondition/1");
        if (response.data.success && response.data.data) {
          const termData = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;
          setTermsCondition(termData);
        }
      } catch (error) {
        console.error("Error fetching terms:", error);
      }
    };
    fetchTerms();
  }, []);

  // Fetch doctors and logged-in user info
  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axiosInstance.get(`/getActiveDoctors`);
        setDoctors(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching doctors:', error);
      }
    };

    const fetchLoggedInDoctor = async () => {
      try {
        // Check both common locations for user data
        const userMedical = JSON.parse(localStorage.getItem('userMedical'));
        const user = JSON.parse(localStorage.getItem('user'));
        const userData = userMedical?.data || user;

        if (userData) {
          setLoggedInDoctor(userData);
        }
      } catch (error) {
        console.error('Error fetching logged-in doctor:', error);
      }
    };

    fetchDoctors();
    fetchLoggedInDoctor();
  }, []);

  // Handle enhanced doctors list (current user first)
  useEffect(() => {
    if (!serviceModalOpen) return;
    if (!loggedInDoctor) return;
    if (serviceFormData.sent_by) return;

    const userEntry = {
      id: loggedInDoctor.id,
      displayName: loggedInDoctor.fullName || loggedInDoctor.displayName || loggedInDoctor.name || "Current User",
      isLoggedInUser: true
    };

    const merged = [userEntry, ...doctors.filter(d => d.id !== loggedInDoctor.id)];
    setEnhancedDoctors(merged);

    // Auto-select logged-in user if adding new service
    if (!selectedService && !serviceFormData.sent_by) {
      setServiceFormData(prev => ({ ...prev, sent_by: userEntry.id }));
    }
  }, [serviceModalOpen, loggedInDoctor, doctors, selectedService]);

  const hospitalSettings =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("businessSetting"))
      : null;

  // const hospitalName = hospitalSettings?.official_name || "Hospital Name";
  const hospitalCR = hospitalSettings?.cr_number || "";
  const hospitalVAT = hospitalSettings?.vat_number || "";
  const hospitalEmail = hospitalSettings?.email || "abcd@gmail.com";
  const hospitalPhone = hospitalSettings?.telephone_1 || "+973 35135498";
  const hospitalLogo =
    hospitalSettings?.base64Image || hospitalSettings?.image
      ? hospitalSettings.image?.startsWith("http")
        ? hospitalSettings.image
        : `${baseurImage}${hospitalSettings.image}`
      : logo;

  const businessSetting = JSON.parse(localStorage.getItem("businessSetting"));

  const phone = businessSetting?.telephone_1 || "N/A";
  const hospitalName = businessSetting?.official_name || "N/A";
  const email = businessSetting?.email || "N/A";
  const website = businessSetting?.website;

  // Retrieve logo logic consistent with PatientBilling if base64Image is stored
  const getLogo = () => {
    if (hospitalSettings?.base64Image) {
      return hospitalSettings.base64Image;
    }
    // Fallback to URL if no base64
    if (hospitalSettings?.image) {
      return hospitalSettings.image.startsWith("http")
        ? hospitalSettings.image
        : `${baseurImage}${hospitalSettings.image}`;
    }
    return logo;
  };
  const finalLogo = getLogo();

  // Load available services and inventory
  useEffect(() => {
    loadAvailableServices();
    loadAvailableInventory();
    loadDoctors();
    loadPatientServices();
    loadPatientInventory();
    loadLabRequestServices();
    checkPatientInsuranceCard();

    // Listen for insurance card changes elsewhere in the app
    const off = EventBus.on("insurance:cardAdded", async (e) => {
      try {
        if (
          !e?.detail?.patientId ||
          Number(e.detail.patientId) !== Number(patientId)
        )
          return;
        await checkPatientInsuranceCard();
      } catch (_) { }
    });
    return () => {
      off && off();
    };
  }, [patientId, refreshKey]);

  //   const amountAfterDiscount = Number(service.amount_after_discount || 0);
  // const netAmount = Number(service.netAmount ?? service.net_amount ?? 0);

  // const vatAmount =
  //   netAmount > 0 && amountAfterDiscount > 0
  //     ? (netAmount - amountAfterDiscount).toFixed(2)
  //     : "0.00";


  // Separate effect to handle patient details updates from parent
  useEffect(() => {
    if (patientDetailsFromParent && (Array.isArray(patientDetailsFromParent) ? patientDetailsFromParent.length > 0 : true)) {
      setPatientDetails(patientDetailsFromParent);
    } else {
      axiosInstance
        .get(`getPatientById/${patientId}`)
        .then((res) => {
          if (res.data?.success || res.data?.data) {
            setPatientDetails(res.data.data || res.data);
          }
        })
        .catch((err) => console.error("Error loading patient details:", err));
    }
  }, [patientDetailsFromParent, patientId]);

  const nowStr = new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const [labServices, setLabServices] = useState([]);
  const [labTotalPrice, setLabTotalPrice] = useState(0);

  const loadAvailableServices = async () => {
    try {
      // Use same endpoint backing Service.jsx
      const response = await axiosInstance.get(`getServices`);
      const list = (response.data?.data || []).map((item) => ({
        id: item.id,
        code: item.code,
        serviceName: item.name,
        description: item.description,
        standardCost: item.standard_price,
        secondaryCost: item.secondary_price,
        insurancePrice: item.insurance_price,
        duration: item.duration,
        // VAT fields
        vatLabel: item.vat, // expected "Yes" | "No"
        vatEnabled: (item.vat || "").toString().toLowerCase() === "yes",
        vatValue: Number(item.vat_value) || 0,
      }));
      setAvailableServices(list);
    } catch (error) {
      console.error("Error loading services:", error);
    }
  };

  const serviceDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        serviceDropdownRef.current &&
        !serviceDropdownRef.current.contains(event.target)
      ) {
        setShowServiceSuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const loadAvailableInventory = async () => {
    try {
      // Fetch drugs for inventory from external API
      const response = await axiosInstance.get(`getDrugs`);
      const list = (response.data?.data || []).map((d) => ({
        id: d.id,
        name: d.name,
        price: Number(d.price) || 0,
        quantity: Number(d.quantity) || 0,
      }));
      setAvailableInventory(list);
    } catch (error) {
      console.error("Error loading inventory:", error);
    }
  };

  const loadPatientServices = async () => {
    try {
      const response = await axiosInstance.get(
        `GetPatientServices/${patientId}`
      );
      const data = response.data?.data;
      const results = Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data)
          ? data
          : [];
      // Capture server-provided totals if available
      const apiPlanTotal = Number(data?.planTotal) || 0;
      const apiCompletedTotal = Number(data?.completedTotal) || 0;
      const apiTotalPlanServices = Number(data?.totalPlanServices) || 0;
      const apiTotalCompleteServices = Number(data?.totalCompleteServices) || 0;
      setPlanTotal(apiPlanTotal);
      setCompletedTotal(apiCompletedTotal);
      setTotalPlanServices(apiTotalPlanServices);
      setTotalCompleteServices(apiTotalCompleteServices);
      setServices(results);
    } catch (error) {
      console.error("Error loading patient services:", error);
    }
  };

  const loadPatientInventory = async () => {
    try {
      const response = await axiosInstance.get(
        `getPharmacyByPatientId/${patientId}`
      );

      const data = response.data?.data;
      const results = Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data)
          ? data
          : [];
      setInventoryItems(results);
    } catch (error) {
      console.error("Error loading patient inventory:", error);
      setInventoryItems([]);
    }
  };

  const loadLabRequestServices = async () => {
    try {
      const response = await axiosInstance.get(
        `getLabRequestsByPatient/${patientId}`
      );
      const list = Array.isArray(response.data?.data) ? response.data.data : [];

      let allServices = [];
      let totalVal = 0;

      list.forEach((request) => {
        const reqId = request.request_id || request.id;
        const reqDate = request.request_date;

        if (request.services && Array.isArray(request.services)) {
          const servicesWithId = request.services.map((s) => ({
            ...s,
            parentRequestId: reqId,
            request_date: reqDate,
            billing_status: request.billing_status,
            net_amount: request.net_amount, // Parent request ka net_amount
          }));
          allServices = [...allServices, ...servicesWithId];
        }
        // Total calculate karo request ke net_amount se
        totalVal += Number(request.net_amount ?? 0);
      });

      setLabServices(allServices);
      setLabTotalPrice(totalVal);
    } catch (error) {
      console.error("Error loading lab request services:", error);
      setLabServices([]);
      setLabTotalPrice(0);
    }
  };



  const loadDoctors = async () => {
    try {
      const response = await axiosInstance.get(`getActiveDoctors`);
      setDoctors(Array.isArray(response.data?.data) ? response.data.data : []);
    } catch (error) {
      console.error("Error loading doctors:", error);
    }
  };

  // Check if patient has active insurance card
  const checkPatientInsuranceCard = async () => {
    try {
      const response = await axiosInstance.get(
        `getInsuranceCardsByPatientId/${patientId}`
      );
      const cards = Array.isArray(response.data?.data)
        ? response.data.data
        : [];
      const activeCard = cards.find(
        (card) =>
          card.status === "Active" ||
          (card.expiry_date && new Date(card.expiry_date) > new Date())
      );
      const hasActiveCard = !!activeCard;
      setHasActiveInsuranceCard(hasActiveCard);

      if (hasActiveCard && activeCard.company_id) {
        setInsuranceCompanyId(activeCard.company_id);
        try {
          const priceRes = await axiosInstance.get(`getCompanyServicePrices/${activeCard.company_id}`);
          const companyPrices = {};
          (priceRes.data?.data || []).forEach(row => {
            if (row.company_price !== null && row.company_price !== undefined) {
              companyPrices[row.service_id] = Number(row.company_price);
            }
          });
          setAvailableServices(prev => prev.map(s => ({
            ...s,
            companyPrice: companyPrices[s.id] ?? null,
          })));
        } catch (_) {}
      } else {
        setInsuranceCompanyId(null);
      }
    } catch (error) {
      console.error("Error checking insurance card:", error);
      setHasActiveInsuranceCard(false);
      setInsuranceCompanyId(null);
    }
  };

  const safeServices = Array.isArray(services) ? services : [];

  const fallbackPlanTotal = safeServices
    .filter(
      (service) => (service.status || "").toString().toLowerCase() === "plan"
    )
    .reduce(
      (sum, service) => sum + (service.netAmount ?? service.net_amount ?? 0),
      0
    );

  const fallbackCompletedTotal = safeServices
    .filter((service) => {
      const s = (service.status || "").toString().toLowerCase();
      return s === "completed" || s === "complete";
    })
    .reduce(
      (sum, service) => sum + (service.netAmount ?? service.net_amount ?? 0),
      0
    );

  const displayPlanTotal = planTotal || fallbackPlanTotal || 0;
  const displayCompletedTotal = completedTotal || fallbackCompletedTotal || 0;
  const formatBhd = (n) => `${Number(n || 0).toFixed(3)} BHD`;

  const fallbackPlanCount = safeServices.filter(
    (s) => (s.status || "").toString().toLowerCase() === "plan"
  ).length;
  const fallbackCompleteCount = safeServices.filter((s) => {
    const st = (s.status || "").toString().toLowerCase();
    return st === "complete" || st === "completed";
  }).length;
  const displayPlanCount = totalPlanServices || fallbackPlanCount;
  const displayCompleteCount = totalCompleteServices || fallbackCompleteCount;

  const handleAddService = () => {
    checkPatientInsuranceCard();
    setSelectedService(null);
    setServiceFormData({
      serviceId: "",
      extraNotes: "",
      discountType: "Amount",
      discountValue: 0,
      status: "Plan",
      customCost: "",
      quantity: 1,
    });
    setSearchServiceQuery("");
    setShowServiceSuggestions(false);
    setServiceModalOpen(true);
  };

  const handleEditService = (service) => {
    setSelectedService(service);

    // Use the correct service ID field name
    const serviceId = service.serviceId || service.service_id;

    // Set the search query to show the selected service name
    const serviceData = availableServices.find((s) => s.id === serviceId);

    // Initialize customCost with the SAVED cost from the patient service record
    // Use the actual saved price/custom_cost from the service record, not the default from master data
    let initialCost = service.price || service.custom_cost || service.customCost || "";

    // If no saved cost exists (shouldn't happen, but fallback to default)
    if (!initialCost && serviceData) {
      initialCost = hasActiveInsuranceCard
        ? serviceData.companyPrice ??
        serviceData.insurancePrice ??
        serviceData.insurance_price ??
        serviceData.standardCost
        : serviceData.standardCost;
      initialCost = initialCost || "";
    }

    setSearchServiceQuery(
      serviceData
        ? `${serviceData.code} - ${serviceData.serviceName}`
        : `${service.serviceCode || service.service_code || ""} - ${service.serviceName || service.service_name || ""
        }`
    );

    setServiceFormData({
      serviceId: serviceId,
      extraNotes: service.extraNotes || service.extra_notes || "",
      discountType: service.discountType || service.discount_type || "Amount",
      discountValue: service.discount_value || service.discount_value || 0,
      status: service.status || "Plan",
      customCost: initialCost,
      quantity: service.quantity || 1,
      sent_by: service.sent_by || "",
    });

    setShowServiceSuggestions(false);
    setServiceModalOpen(true);
  };

  const handleDeleteService = async (serviceId, serviceDefinitionId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This service will be removed from the patient!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
    });

    if (confirm.isConfirmed) {
      try {
        // Restore linked inventory and log to stock movements before deleting
        if (serviceDefinitionId) {
          try {
            await axiosInstance.post(`restoreServiceInventory`, { service_id: serviceDefinitionId, patient_id: patientId });
          } catch (e) {
            console.warn("Inventory restore failed:", e);
          }
        }
        await axiosInstance.delete(`DeletePatientService/${serviceId}`);
        Swal.fire(
          "Removed!",
          "Service has been removed from patient.",
          "success"
        );
        dispatch(triggerLabRefresh());
        loadPatientServices();
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleDiscountValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const totalPrice = (Number(serviceFormData.customCost) || 0) * (Number(serviceFormData.quantity) || 1);

    if (serviceFormData.discountType === "Percentage") {
      if (value > globalDiscountLimit) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Percentage discount cannot exceed ${globalDiscountLimit}%`,
        });
        return;
      }
    } else {
      const maxAllowedAmount = (totalPrice * globalDiscountLimit) / 100;
      if (value > maxAllowedAmount) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Amount discount cannot exceed ${globalDiscountLimit}% of total price (max ${maxAllowedAmount.toFixed(3)} BHD)`,
        });
        return;
      }
    }

    setServiceFormData({ ...serviceFormData, discountValue: value });
  };

  const handleServiceSubmit = async (e) => {
    e.preventDefault();

    const resolvedPatientId = Number(patientId) || null;
    const resolvedServiceId = Number(serviceFormData.serviceId) || null;

    // More specific validation messages
    if (!resolvedPatientId) {
      Swal.fire(
        "Error",
        "Patient information is missing. Please refresh the page and try again.",
        "error"
      );
      return;
    }

    if (!resolvedServiceId) {
      Swal.fire(
        "Error",
        "Please select a service from the dropdown list before adding.",
        "error"
      );
      return;
    }

    const selectedServiceData = availableServices.find(
      (s) => Number(s.id) === resolvedServiceId
    );
    if (!selectedServiceData) {
      Swal.fire("Error", "Please select a valid service", "error");
      return;
    }

    // Frontend duplicate check removed per requirement to allow adding the same service multiple times

    // const discountLimit = await fetchDiscountLimit();

    // if(serviceFormData.discountType==="Percentage"){
    //   if(serviceFormData.discountValue > discountLimit){
    //     Swal.fire("Invalid Discount",`Percentage discount cannot exceed ${discountLimit}%`,'error');
    //     return;
    //   }
    // }

    if (!selectedService) {
      const consentCheck = await checkForceConsents(resolvedServiceId, resolvedPatientId);
      if (!consentCheck.ok) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Consent Required',
          html: `This service requires the following consent(s) to be added today before it can be added:<br/><b>${consentCheck.missing.map(m => m.name).join(', ')}</b>`,
          showCancelButton: true,
          confirmButtonText: 'Add Consent Now',
          cancelButtonText: 'Cancel',
        });
        if (result.isConfirmed) {
          setPendingMissingConsents(consentCheck.missing);
        }
        return;
      }
    }

    // Use the edited customCost from form state, or fallback to default if empty
    await checkPatientInsuranceCard();

    // Determine the actual cost to use - prioritize user's edited value
    const actualCost = serviceFormData.customCost || (
      hasActiveInsuranceCard
        ? selectedServiceData.companyPrice ??
        selectedServiceData.insurancePrice ??
        selectedServiceData.insurance_price ??
        selectedServiceData.standardCost
        : selectedServiceData.standardCost
    );

    // Calculate discount based on the actual cost (edited or default)
    const discount =
      serviceFormData.discountType === "Percentage"
        ? (actualCost * serviceFormData.discountValue) / 100
        : serviceFormData.discountValue;

    const serviceData = {
      serviceId: resolvedServiceId,
      discount_type: serviceFormData.discountType,
      discount_value: serviceFormData.discountValue,
      extra_notes: serviceFormData.extraNotes,
      price: actualCost,
      custom_cost: actualCost,
      baseCost: actualCost,
      quantity: Number(serviceFormData.quantity) || 1,
      sent_by: serviceFormData.sent_by,
    };

    try {
      if (selectedService) {
        // Use UpdatePatientServices/:id for editing existing service record
        await axiosInstance.put(
          `UpdatePatientServices/${selectedService.id}`,
          serviceData
        );
      } else {
        // Keep add flow as-is
        await axiosInstance.post(`AddPatientServices`, {
          patientId: resolvedPatientId,
          ...serviceData,
          branch_id: parseInt(localStorage.getItem('activeBranchId')) || null,
        });
        // Deduct linked inventory items and log to stock movements
        if (resolvedServiceId) {
          try {
            await axiosInstance.post(`deductServiceInventory`, { service_id: resolvedServiceId, patient_id: resolvedPatientId });
          } catch (e) {
            console.warn("Inventory deduction failed:", e);
          }
        }
      }
      dispatch(triggerLabRefresh());
      setServiceModalOpen(false);
      loadPatientServices();
    } catch (error) {
      console.error("Submit failed", error);
      const msg = error.response?.data?.message || "Something went wrong!";
      Swal.fire("Error", msg, "error");
    }
  };

  const handleStatusChange = async (patientId, newStatus) => {
    try {
      const res = await axiosInstance.put(
        `updatePatientPharmacyStatus/${patientId}`,
        { status: newStatus }
      );
      if (res.data.success) {
        Swal.fire("Success", "Patient status updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          res.data.message || "failed to updated the status",
          "error"
        );
      }
    } catch (error) {
      console.error("Status change failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  // const truncateStyle = {
  //   maxWidth: "150px",
  //   whiteSpace: "nowrap",
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  // };

  const handleServiceStatusChange = async (serviceId, newStatus) => {
    try {
      const res = await axiosInstance.put(
        `updatePatientServicesStatus/${serviceId}`,
        { status: newStatus }
      );
      if (res.data.success) {
        dispatch(triggerLabRefresh());
        loadPatientServices(); // Refresh the services list
      } else {
        Swal.fire(
          "Error",
          res.data.message || "Failed to update service status",
          "error"
        );
      }
    } catch (error) {
      console.error("Service status change failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  // Inventory functions
  const handleAddInventory = () => {
    setSelectedInventory(null);
    setInventoryFormData({
      inventoryId: "",
      quantity: 1,
    });
    setInventoryModalOpen(true);
  };

  const handleEditInventory = (item) => {
    setSelectedInventory(item);
    setInventoryFormData({
      inventoryId: item.drugId,
      quantity: item.quantity,
    });
    try {
      const inv = availableInventory.find((i) => i.id === item.drugId);
      if (inv) {
        setSearchInventoryQuery(`${inv.id} - ${inv.name}`);
      } else {
        setSearchInventoryQuery(`${item.drugId} - ${item.drug_name}`);
      }
    } catch (_) { }
    setInventoryModalOpen(true);
  };

  const handleDeleteInventory = async (itemId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This medicine will be removed from the patient!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axiosInstance.delete(`deletePatientPharmacy/${itemId}`);
        Swal.fire(
          "Removed!",
          "Medicine has been removed from patient.",
          "success"
        );
        loadPatientInventory();
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleDeleteLabRequest = async (requestId) => {
    if (!requestId) {
      console.error("No request ID provided for deletion");
      Swal.fire("Error", "Invalid Request ID", "error");
      return;
    }

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This lab request will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axiosInstance.delete(`deleteLabRequest/${requestId}`);
        Swal.fire("Deleted!", "Lab request has been deleted.", "success");
        loadLabRequestServices();
        dispatch(triggerLabRefresh());
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleInventorySubmit = async (e) => {
    e.preventDefault();

    const selectedInventoryData = availableInventory.find(
      (i) => i.id === inventoryFormData.inventoryId
    );
    if (!selectedInventoryData) {
      Swal.fire("Error", "Please select a valid inventory item", "error");
      return;
    }

    // Validate requested quantity against available stock before submit
    const requestedQty = Number(inventoryFormData.quantity) || 0;
    const availableQty = Number(selectedInventoryData.quantity) || 0;
    if (requestedQty < 1) {
      Swal.fire("Invalid Quantity", "Quantity must be at least 1", "error");
      return;
    }
    if (requestedQty > availableQty) {
      Swal.fire(
        "Insufficient Stock",
        `Only ${availableQty} unit(s) available for ${selectedInventoryData.name}.`,
        "error"
      );
      return;
    }

    try {
      if (selectedInventory) {
        const pharmacyPayload = {
          drugId: inventoryFormData.inventoryId,
          quantity: inventoryFormData.quantity,
        };

        await axiosInstance.put(
          `updatePatientPharmacy/${selectedInventory.id}`,
          pharmacyPayload
        );
        Swal.fire(
          "Success",
          "Patient pharmacy record updated successfully",
          "success"
        );
      } else {
        // For adding new patient pharmacy record
        const pharmacyPayload = {
          drugId: inventoryFormData.inventoryId,
          quantity: inventoryFormData.quantity,
          branch_id: parseInt(localStorage.getItem('activeBranchId')) || null,
        };

        await axiosInstance.post(
          `addPatientPharmacy/${patientId}`,
          pharmacyPayload
        );
        Swal.fire("Success", "Medicine added successfully", "success");
      }
      setInventoryModalOpen(false);
      loadPatientInventory();
      loadAvailableInventory(); // Refresh available inventory
    } catch (error) {
      console.error("Submit failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  // Print functionality
  const handlePrintClick = () => {
    setIsSelectingForPrint(true);
    setSelectedPrintIds([]);
    setPrintModalOpen(true);
  };

  const handleServiceSelection = (serviceId) => {
    setSelectedPrintIds((prev) => {
      if (prev.includes(serviceId)) {
        return prev.filter((id) => id !== serviceId);
      } else {
        return [...prev, serviceId];
      }
    });
  };

  const handleSelectAllServices = () => {
    if (selectedPrintIds.length === safeServices.length) {
      setSelectedPrintIds([]);
    } else {
      setSelectedPrintIds(safeServices.map((service) => service.id));
    }
  };

  const handlePrintSelected = () => {
    if (selectedPrintIds.length === 0) {
      Swal.fire(
        "No Selection",
        "Please select at least one service to print",
        "warning"
      );
      return;
    }

    const selectedServices = safeServices.filter((service) =>
      selectedPrintIds.includes(service.id)
    );

    // Generate print content
    const printContent = generatePrintContent(selectedServices);
    printServices(printContent);

    setPrintModalOpen(false);
    setIsSelectingForPrint(false);
    setSelectedPrintIds([]);
  };

  const generatePrintContent = (services) => {
    const now = new Date();
    const currentDate = now.toLocaleDateString("en-GB");

    // Calculate totals
    const totalAmount = services.reduce(
      (sum, s) => sum + Number(s.netAmount ?? s.net_amount ?? 0),
      0
    );
    // Calculate total discount
    const totalDiscount = services.reduce((sum, s) => {
      const dVal = Number(s.discountValue ?? s.discount_value ?? 0);
      // If it's percentage, we might need original cost to calc amount, but assuming discountValue is the amount if type is Amount
      // If discount logic is complex, might need to re-calc.
      // Simple approach: sum up (standard_price - net_amount) if available, or just use discount fields
      // Let's rely on Price - NetAmount if available

      // However, let's look at the mapping logic in the rows:
      // netAmount is calculated.
      // Let's iterate rows to get exact table data first
      return sum;
    }, 0);

    const servicesRows = services
      .map((s, idx) => {
        const serviceData = availableServices.find(
          (avail) => avail.id === (s.serviceId ?? s.service_id)
        );
        const name = serviceData?.serviceName || s.serviceName || "";
        const code = serviceData?.code || s.serviceCode || "";

        // The saved `amount` is unit cost x quantity, so divide it back out to get
        // the single cost; fall back to the master price when nothing is saved.
        const qty = Number(s.quantity) > 0 ? Number(s.quantity) : 1;
        const savedTotal = Number(s.amount ?? s.custom_cost ?? 0);
        const cost = savedTotal > 0
          ? savedTotal / qty
          : hasActiveInsuranceCard
            ? serviceData?.companyPrice ??
            serviceData?.insurancePrice ??
            serviceData?.insurance_price ??
            s.companyPrice ??
            s.insurancePrice ??
            s.insurance_price ??
            0
            : serviceData?.standardCost || s.standardCost || 0;

        const discountVal = Number(s.discountValue ?? s.discount_value ?? 0);
        const discountType = s.discountType || s.discount_type || "Amount";
        let discountAmount = 0;
        if (discountType.toLowerCase() === "percentage") {
          // Percentage discounts apply to the full line total (cost x qty)
          discountAmount = ((savedTotal > 0 ? savedTotal : Number(cost) * qty) * discountVal) / 100;
        } else {
          discountAmount = discountVal;
        }

        const net = Number(
          s.netAmount ?? s.net_amount ?? Number(cost) - discountAmount
        );
        // VAT
        const vatVal = Number(s.vat_value ?? serviceData?.vatValue ?? 0);
        // Typically VAT is on Net? Or Cost? Assuming VAT is included/calculated in net or separate.
        // PatientBilling template has a VAT column.
        // Let's just use what we have.

        return `<tr>
           <td style="border: 1px solid #000;">${idx + 1}</td>
           <td style="border: 1px solid #000;">${s.createdAt || s.created_at
            ? new Date(s.createdAt || s.created_at).toLocaleDateString(
              "en-GB"
            )
            : currentDate
          }</td>
           <td style="border: 1px solid #000;">${code}</td>
           <td style="border: 1px solid #000;">${name}</td>
           <td style="border: 1px solid #000;">${Number(cost).toFixed(3)}</td>
           <td style="border: 1px solid #000;">${Number(discountAmount).toFixed(
            3
          )}</td>
           <td style="border: 1px solid #000;">${vatVal}%</td>
           <td style="border: 1px solid #000;">${net.toFixed(3)}</td>
         </tr>`;
      })
      .join("");

    const patientName = patientDetails
      ? `${patientDetails.firstName || ""} ${patientDetails.lastName || ""}`
      : patientDetails?.patientName || "Patient";
    const patientGender = patientDetails?.gender || "";
    // Calculate Age if DOB available
    const calculateAge = (dob) => {
      if (!dob) return "";
      const diff = Date.now() - new Date(dob).getTime();
      const ageDate = new Date(diff);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    };
    const patientAge = calculateAge(patientDetails?.dateOfBirth);
    const patientCPR =
      patientDetails?.civilIdNumber || patientDetails?.cpr || "";
    const patientPhone =
      patientDetails?.mobileNumber || patientDetails?.phone || "";

    return `<!DOCTYPE html>
<html>
<head>
<title>Patient Services Report</title>
<style>
 
 @page {
    size: auto;
    margin: 20px; /* 20px gap on all sides */
  }
  
}
 body{
 font-family: Arial, sans-serif;
 }
.logo {
  text-align: center;
}
 body{
 font-family: Arial, sans-serif;
 }
.top-section {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.billingInvoice h2 {
  font-size: 25px;
  font-weight: 600;
}

.patient-info {
  text-align: left;
  font-size: 14px;
}

.invoice-title {
  margin-top: 30px;
  text-align: center;
}

.billingInvoice p,
.billingInvoice h2 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.paymentLine {
  display: flex;
  justify-content: end;
  margin-top: 50px;
}

.paymentLine p {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #000;
}
.paymentLine p:last-child{
border:unset;
}
table th,
table td {
  text-align: left;
  padding: 2px 10px;
  font-size:14px
}
.top-section p,.paymentLine p{
font-size:14px
}
.termsACon li{
font-size:12px;
}
 .termsACon ul{
 padding-left:12px;
 }

.footer {
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  color: #000;
  bottom:0px;
}
 
</style>
</head>
<body>



<div class="billingInvoice">
<div class="logo">
<img height=80 src="${finalLogo}" onError="this.style.display='none'" />
</div>
<div class="top-section">
<div class="hospital-info">
<p><strong>${hospitalName}</strong></p>
<p><strong>CR:</strong> ${hospitalCR}</p>
<p><strong>VAT No.</strong> ${hospitalVAT}</p>
</div>

<div class="patient-info">
<strong>Patient Name: </strong> ${patientName}
<p>${patientGender} ${patientAge ? `(${patientAge} YO)` : ""} </p>
<p><strong>CPR:</strong> ${patientCPR} </p>
<p><strong>Phone:</strong> ${patientPhone}</p>
</div>
</div>
<div class="invoice-title">
<h2>Services Report</h2>
<p style="margin-top:20px"><strong>Date:</strong> ${currentDate}</p>
</div>
</div>

<div class="paymentLine">
<p> <strong>Total Amount: <span style="color:#318965">${totalAmount.toFixed(
      3
    )} BHD</span> </strong></p>
</div>
<table style="width: 100%; border-collapse: collapse; font-size: 14px;">
<thead>
<tr>
<th style="border: 1px solid #000;">#</th>
<th style="border: 1px solid #000;">Date</th>
<th style="border: 1px solid #000;">Code</th>
<th style="border: 1px solid #000;">Service Name</th>
<th style="border: 1px solid #000;">Price</th>
<th style="border: 1px solid #000;">Discount</th>
<th style="border: 1px solid #000;">VAT</th>
<th style="border: 1px solid #000;">Total</th>
</tr>
</thead>

<tbody>
${servicesRows}
</tbody>

<tfoot>
<tr>
<td colspan="7" style="border: 1px solid #000; text-align: right;"><strong>Total</strong></td>
<td style="border: 1px solid #000; text-align: right;"><strong>${totalAmount.toFixed(
      3
    )} BHD</strong></td>
</tr>
</tfoot>
</table>

<h5 style="margin-top:20px">Terms & Conditions</h5>
<div style="margin-top:10px;" class="termsACon">
 
<ul>
<li>${termsCondition?.content || ""}</li>
</ul>
</div>

 <div class="footer">
      <div font-size: 12px; text-align: center; color: rgb(0, 0, 0);">
        Hospital Name: ${hospitalName} | Email: 
        <span style="border-bottom: 1px solid rgb(44, 100, 223); color: rgb(44, 100, 223);">
         ${email}
        </span> 
        | Phone: ${phone} | 
        <span style="border-bottom: 1px solid rgb(44, 100, 223); color: rgb(44, 100, 223);">
          Website: ${website}
        </span>
      </div>
    </div>
</div>

<script>
  window.onload = () => {
      setTimeout(() => {
          window.print();
      }, 500);

      window.onafterprint = () => {
          window.close();
      };
  };
</script>


</body>
</html>`;
  };

  const printServices = (content) => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
    // Print logic is handled by the script injected in content
  };

  const filteredServices = availableServices.filter(
    (service) =>
      service.serviceName
        ?.toLowerCase()
        .includes(searchServiceQuery.toLowerCase()) ||
      service.code?.toLowerCase().includes(searchServiceQuery.toLowerCase())
  );

  const filteredInventory = availableInventory.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchInventoryQuery.toLowerCase()) ||
      item.id?.toString().includes(searchInventoryQuery)
  );

  // Filter services based on search term
  const filteredServicesTable = safeServices.filter((service) => {
    if (!serviceTableSearchTerm) return true;
    const q = serviceTableSearchTerm.toLowerCase();
    const serviceData = availableServices.find(
      (s) => s.id === (service.serviceId ?? service.service_id)
    );
    return (
      (serviceData?.code && serviceData.code.toLowerCase().includes(q)) ||
      (serviceData?.serviceName &&
        serviceData.serviceName.toLowerCase().includes(q)) ||
      (serviceData?.description &&
        serviceData.description.toLowerCase().includes(q)) ||
      (service.serviceCode && service.serviceCode.toLowerCase().includes(q)) ||
      (service.serviceName && service.serviceName.toLowerCase().includes(q)) ||
      (service.description && service.description.toLowerCase().includes(q)) ||
      (service.extra_notes && service.extra_notes.toLowerCase().includes(q)) ||
      (service.status && service.status.toLowerCase().includes(q))
    );
  });

  // Filter inventory based on search term
  const safeInventoryItems = Array.isArray(inventoryItems)
    ? inventoryItems
    : [];
  const filteredInventoryTable = safeInventoryItems.filter((item) => {
    if (!inventoryTableSearchTerm) return true;
    const q = inventoryTableSearchTerm.toLowerCase();
    return (
      (item.drug_name && item.drug_name.toLowerCase().includes(q)) ||
      (item.drugId && item.drugId.toString().includes(q)) ||
      (item.quantity && item.quantity.toString().includes(q)) ||
      (item.status && item.status.toLowerCase().includes(q))
    );
  });

  // Pagination calculation
  const totalServicePages =
    Math.ceil(filteredServicesTable.length / servicesPerPage) || 1;
  const totalInventoryPages =
    Math.ceil(filteredInventoryTable.length / inventoryPerPage) || 1;

  const paginatedServices = filteredServicesTable.slice(
    (currentServicePage - 1) * servicesPerPage,
    currentServicePage * servicesPerPage
  );

  const paginatedInventory = filteredInventoryTable.slice(
    (currentInventoryPage - 1) * inventoryPerPage,
    currentInventoryPage * inventoryPerPage
  );

  // Reset to first page if dataset size changes
  useEffect(() => {
    setCurrentServicePage(1);
  }, [services.length]);
  useEffect(() => {
    setCurrentInventoryPage(1);
  }, [safeInventoryItems.length]);

  return (
    <div className="patient-services-container">
      {/* Summary Cards */}
      <div className="summary-cards mb-3">
        <div className="row justify-content-center">
          <div className="col-md-3 cr1 ">
            <div className="cardBorder  serviceCard p20">
              <div className="d-flex justify-content-between">
                <div className="pe-3">
                  <h6>Plan Services</h6>

                  <h5>{formatBhd(displayPlanTotal)}</h5>
                </div>
                <div className="avtar avtar-s bg-light-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    {/* Clipboard body */}
                    <rect
                      x="5"
                      y="3"
                      width="14"
                      height="18"
                      rx="2"
                      stroke="#3f75c7"
                      strokeWidth="2"
                    />
                    {/* Clipboard top clip */}
                    <rect
                      x="9"
                      y="1"
                      width="6"
                      height="4"
                      rx="1"
                      fill="#3f75c7"
                    />
                    {/* Lines representing planned tasks */}
                    <line
                      x1="7"
                      y1="8"
                      x2="17"
                      y2="8"
                      stroke="#3f75c7"
                      strokeWidth="2"
                    />
                    <line
                      x1="7"
                      y1="12"
                      x2="17"
                      y2="12"
                      stroke="#3f75c7"
                      strokeWidth="2"
                    />
                    <line
                      x1="7"
                      y1="16"
                      x2="13"
                      y2="16"
                      stroke="#3f75c7"
                      strokeWidth="2"
                    />
                  </svg>
                </div>

                {/* <div className="numberService">
                 
                  <p className="text-primary">
                    {" "}
                    <i className="ti ti-arrow-up-right"></i> {displayPlanCount}{" "}
                  </p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-3 cr2">
            <div className="cardBorder serviceCard p20">
              <div className="d-flex justify-content-between">
                <div className="pe-3">
                  <h6>Completed Services</h6>

                  <h5> {formatBhd(displayCompletedTotal)}</h5>
                </div>
                <div className="avtar avtar-s bg-light-success">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle cx="12" cy="12" r="10" fill="#28a745" />{" "}
                    {/* Green background */}
                    <path
                      d="M8 12.5l3 3 5-6"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* 
                  <p className="text-success">
                    {" "}
                    <i className="ti ti-arrow-up-right"></i>{" "}
                    {displayCompleteCount}{" "}
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="mb-3 cardBorder">
        <div className="tableHeader d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <h5 className="mb-0">Services</h5>
            <div
              className="tableSearch"
              style={{ position: "relative", width: "250px" }}
            >
              <input
                type="text"
                placeholder="Search services..."
                className="form-control"
                value={serviceTableSearchTerm}
                onChange={(e) => setServiceTableSearchTerm(e.target.value)}
                style={{ paddingLeft: "35px" }}
              />
              <span className="searchIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="gray"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </span>
            </div>
          </div>
          {hasActiveInsuranceCard && (
            <span className="badge bg-success ms-2"></span>
          )}
          <div className="d-flex gap-2">
            <button
              className="bgBtn btn-sm d-flex align-items-center gap-1"
              style={{ fontSize: 13, padding: "5px 12px" }}
              onClick={handlePrintClick}
              disabled={safeServices.length === 0}
              title={
                safeServices.length === 0
                  ? "No services to print"
                  : "Print selected services"
              }
            >
              <i className="fas fa-print"></i>
              Print
            </button>
            <button
              className="bgBtn btn-sm d-flex align-items-center gap-1"
              style={{ fontSize: 13, padding: "5px 12px" }}
              onClick={handleAddService}
            >
              Add Service
            </button>
          </div>
        </div>
        <div className="card-body">
          <div style={{ fontSize: 11.5, overflowX: "hidden" }}>
            <table className="table table-sm servicesCompactTable" style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th style={{ width: isSingleBranch ? "8%" : "7%" }}>Date-Time</th>
                  <th style={{ width: isSingleBranch ? "6%" : "5%" }}>Code</th>
                  <th style={{ width: isSingleBranch ? "20%" : "20%" }}>Name</th>
                  <th style={{ width: isSingleBranch ? "12%" : "13%" }}>Notes</th>
                  <th style={{ width: isSingleBranch ? "8%" : "7%" }}>{hasActiveInsuranceCard ? "Cost" : "Cost"}</th>
                  <th style={{ width: "4%" }}>Qty</th>
                  <th style={{ width: isSingleBranch ? "8%" : "7%" }}>Discount</th>
                  <th style={{ width: "4%" }}>VAT</th>
                  <th style={{ width: isSingleBranch ? "8%" : "7%" }}>Net Amt.</th>
                  <th style={{ width: isSingleBranch ? "8%" : "7%" }}>Added By</th>
                  {!isSingleBranch && <th style={{ width: "6%" }}>Branch</th>}
                  <th style={{ width: isSingleBranch ? "7%" : "6%" }}>Status</th>
                  <th className="text-center" style={{ width: "6%" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedServices.map((service, index) => {
                  const getServiceDateKey = (s) => {
                    const ts = s?.createdAt || s?.created_at || s?.dateTime || s?.datetime;
                    const d = ts ? new Date(ts) : null;
                    return d && !isNaN(d.getTime()) ? d.toDateString() : null;
                  };
                  const prevService = index > 0 ? paginatedServices[index - 1] : null;
                  const isNewDateGroup =
                    index > 0 && getServiceDateKey(service) !== getServiceDateKey(prevService);

                  const isLocked = recordLockHours != null && service.createdAt
                    ? (Date.now() - new Date(service.createdAt).getTime()) > recordLockHours * 3600 * 1000
                    : false;
                  const serviceData = availableServices.find(
                    (s) => s.id === (service.serviceId ?? service.service_id)
                  );
                  const vatDisplay = serviceData
                    ? serviceData.vatEnabled
                      ? `${serviceData.vatValue}%`
                      : "0%"
                    : service.vat_value
                      ? `${service.vat_value}%`
                      : "0%";

                  //vat

                  const amountAfterDiscount = Number(service.amount_after_discount || 0);
                  const netAmount = Number(service.netAmount ?? service.net_amount ?? 0);

                  const vatAmount =
                    netAmount > 0 && amountAfterDiscount > 0
                      ? (netAmount - amountAfterDiscount).toFixed(3)
                      : "0.00";

                  return (
                    <tr
                      key={index}
                      className={isNewDateGroup ? "service-date-divider" : undefined}
                    >
                      <td style={{ whiteSpace: "nowrap" }}>
                        {(() => {
                          const ts =
                            service.createdAt ||
                            service.created_at ||
                            service.dateTime ||
                            service.datetime;
                          const d = ts ? new Date(ts) : null;
                          if (!d || isNaN(d.getTime())) return "-";
                          return (
                            <>
                              <div>{d.toLocaleDateString("en-GB")}</div>
                              <div className="text-muted">{d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })}</div>
                            </>
                          );
                        })()}
                      </td>
                      <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{serviceData?.code || service.serviceCode || "-"}</td>
                      <td
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {serviceData?.serviceName || service.serviceName || "-"}
                      </td>
                      <td
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                        title={service.extra_notes || "-"}
                      >
                        {service.extra_notes || "-"}
                      </td>

                      {/* <td>
                        {hasActiveInsuranceCard
                          ? serviceData?.insurancePrice ??
                          serviceData?.insurance_price ??
                          service.insurancePrice ??
                          service.insurance_price ??
                          0
                          : serviceData?.standardCost ||
                          service.standardCost ||
                          0}{" "}
                        BHD
                      </td> */}
                      <td>
                        {(() => {
                          // `amount` is stored as unit cost x quantity, so show the single cost here
                          const qty = Number(service.quantity) > 0 ? Number(service.quantity) : 1;
                          const total = Number(service.amount || service.custom_cost || 0);
                          return (total / qty).toFixed(3);
                        })()} BHD
                      </td>
                      <td>{service.quantity || 1}</td>
                      <td>
                        {(service.discount_value ??
                          service.discount_value ??
                          0) > 0 ? (
                          <>
                            {(
                              service.discountType ||
                              service.discount_type ||
                              ""
                            )
                              .toString()
                              .toLowerCase() === "percentage"
                              ? `${service.discountValue ??
                              service.discount_value
                              }%`
                              : `-${service.discountValue ??
                              service.discount_value
                              } BHD`}
                          </>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{vatAmount} BHD</td>


                      <td>{service.netAmount ?? service.net_amount} BHD</td>
                      <td>{service.sent_by || "-"}</td>
                      {!isSingleBranch && (
                        <td>
                          {(() => {
                            const branchId = service.branch_id;
                            if (!branchId) return "-";
                            if (allBranchSettings && allBranchSettings.length > 0) {
                              const idx = allBranchSettings.findIndex(b => b.id === branchId);
                              if (idx !== -1) {
                                const branch = allBranchSettings[idx];
                                return branch?.official_name || `Branch ${idx + 1}`;
                              }
                            }
                            const active = JSON.parse(localStorage.getItem('activeBranchSettings') || 'null');
                            if (active && active.id === branchId) return active.official_name || "Main Branch";
                            return `Branch #${branchId}`;
                          })()}
                        </td>
                      )}
                      <td style={{ textAlign: "center" }}>
                        {(service.status || "").toString().toLowerCase() === "complete" || (service.status || "").toString().toLowerCase() === "completed" ? (
                          <span className="badge bg-success">Completed</span>
                        ) : (
                          <button
                            className="bgBtn btn-sm"
                            style={{ fontSize: 9, padding: "2px 5px", backgroundColor: "#fff", color: "var(--green)", whiteSpace: "normal", lineHeight: 1.1, width: "auto", maxWidth: "100%" }}
                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = "var(--green)"; e.currentTarget.style.color = "#fff"; }}
                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#fff"; e.currentTarget.style.color = "var(--green)"; }}
                            onClick={() => handleServiceStatusChange(service.id, "Complete")}
                          >
                            Mark Complete
                          </button>
                        )}
                      </td>
                      <td className="text-center">
                        <div
                          onClick={() => !isLocked && handleEditService(service)}
                          style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.5 : 1 }}
                          title={isLocked ? "Record is locked" : "Edit"}
                          className="avtar avtar-xs btn-link-secondary editIcon"
                        >
                          <i className="ti ti-edit f-20" />
                          <span>Edit</span>
                        </div>

                        <div
                          style={{
                            cursor: isLocked || (service.billing_status || "") === "Paid" ? "not-allowed" : "pointer",
                            opacity: isLocked || (service.billing_status || "") === "Paid" ? 0.5 : 1,
                          }}
                          title={
                            isLocked
                              ? "Record is locked"
                              : (service.billing_status || "") === "Paid"
                                ? "Cannot delete paid service"
                                : "Delete"
                          }
                          className="avtar avtar-xs btn-link-secondary deleteIcon"
                          onClick={() =>
                            !isLocked && (service.billing_status || "") !== "Paid"
                              ? handleDeleteService(service.id, service.serviceId || service.service_id)
                              : null
                          }
                        >
                          <i className="ti ti-trash f-20" />
                          <span>Delete</span>
                        </div>

                      </td>
                    </tr>
                  );
                })}
                {paginatedServices.length === 0 && (
                  <tr>
                    <td colSpan={isSingleBranch ? 11 : 12} className="text-center">
                      No services added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {totalServicePages > 1 && (
            <nav className="tablepagination d-flex justify-content-end mt-3 mb-2">
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentServicePage === 1 ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      currentServicePage > 1 &&
                      setCurrentServicePage(currentServicePage - 1)
                    }
                  >
                    &laquo;
                  </button>
                </li>
                <li className="pageNmbr">{`${currentServicePage} of ${totalServicePages}`}</li>
                <li
                  className={`page-item ${currentServicePage === totalServicePages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      currentServicePage < totalServicePages &&
                      setCurrentServicePage(currentServicePage + 1)
                    }
                  >
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>

      {/* Inventory Items Section */}
      <div className="cardBorder mb-3">
        <div className="tableHeader d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <h5 className="mb-0">Pharmacy</h5>
            <div
              className="tableSearch"
              style={{ position: "relative", width: "250px" }}
            >
              <input
                type="text"
                placeholder="Search pharmacy..."
                className="form-control"
                value={inventoryTableSearchTerm}
                onChange={(e) => setInventoryTableSearchTerm(e.target.value)}
                style={{ paddingLeft: "35px" }}
              />
              <span className="searchIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="gray"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </span>
            </div>
          </div>
          {/* No add button here; lab services come from lab requests API */}
          <button
            className="bgBtn btn-sm d-flex align-items-center gap-1"
            style={{ fontSize: 13, padding: "5px 12px" }}
            onClick={handleAddInventory}
          >
            Add Item
          </button>
        </div>
        <div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Sn</th>
                  <th>Date-Time</th>
                  {/* <th>ID</th> */}
                  <th>Name</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Vat%</th>
                  <th>Vat</th>
                  <th>Total</th>
                  <th>Added By</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedInventory.map((item, index) => {
                  const serial =
                    (currentInventoryPage - 1) * inventoryPerPage + index + 1;
                  return (
                    <tr key={index}>
                      <td>{serial}</td>
                      <td>
                        {(() => {
                          const ts =
                            item.created_at ||
                            item.createdAt ||
                            item.dateTime ||
                            item.datetime;
                          const d = ts ? new Date(ts) : null;
                          return d && !isNaN(d.getTime())
                            ? d.toLocaleDateString("en-US", {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                            }) +
                            " " +
                            d.toLocaleTimeString("en-US", {
                              hour: "numeric",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })
                            : "-";
                        })()}
                      </td>
                      {/* <td>{item.drugId || "-"}</td> */}
                      <td>{item.drug_name || "-"}</td>
                      <td>{item.quantity || 0}</td>
                      <td>{item.price || 0} BHD</td>
                      <td>{item.drug_vat_percent}</td>
                      <td>{item.vat_value}</td>
                      <td>{item.net_amount}</td>
                      <td>{item.sent_by || "-"}</td>
                      <td className="text-center">
                        <div
                          onClick={() => handleEditInventory(item)}
                          style={{ cursor: "pointer" }}
                          className="avtar avtar-xs btn-link-secondary editIcon"
                        >
                          <i className="ti ti-edit f-20" />
                          <span>Edit</span>
                        </div>

                        <div
                          style={{
                            cursor:
                              (item.billing_status || "") === "Paid"
                                ? "not-allowed"
                                : "pointer",
                            opacity:
                              (item.billing_status || "") === "Paid" ? 0.5 : 1,
                          }}
                          className="avtar avtar-xs btn-link-secondary deleteIcon"
                          title={
                            (item.billing_status || "") === "Paid"
                              ? "Cannot delete paid item"
                              : "Delete"
                          }
                          onClick={() =>
                            (item.billing_status || "") === "Paid"
                              ? null
                              : handleDeleteInventory(item.id)
                          }
                        >
                          <i className="ti ti-trash f-20" />
                          <span>Delete</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {paginatedInventory.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No medicines added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {totalInventoryPages > 1 && (
            <nav className="tablepagination d-flex justify-content-end mt-3 mb-2">
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentInventoryPage === 1 ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      currentInventoryPage > 1 &&
                      setCurrentInventoryPage(currentInventoryPage - 1)
                    }
                  >
                    &laquo;
                  </button>
                </li>
                <li className="pageNmbr">{`${currentInventoryPage} of ${totalInventoryPages}`}</li>
                <li
                  className={`page-item ${currentInventoryPage === totalInventoryPages
                    ? "disabled"
                    : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      currentInventoryPage < totalInventoryPages &&
                      setCurrentInventoryPage(currentInventoryPage + 1)
                    }
                  >
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>

      <div className="cardBorder">
        <div className="tableHeader d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <h5 className="mb-0">Laboratory Services</h5>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Sn</th>
                  <th>Date</th>
                  <th>Service Name</th>
                  <th>Cost</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {labServices.length > 0 ? (
                  labServices.map((item, index) => {
                    const serial = index + 1;

                    const serviceName =
                      item.serviceName ||
                      item.service ||
                      item.service_name ||
                      item.name ||
                      "-";

                    // ✅ Per-service cost, quantity and total
                    const cost = Number(item.price ?? 0);
                    const quantity = Number(item.quantity ?? 1) || 1;
                    const total = Number(item.total ?? cost * quantity);

                    // ✅ Sirf Date - Bahrain Format: DD/MM/YYYY
                    const displayDate = (() => {
                      if (!item.request_date) return "-";

                      // "2026-02-25" → "25/02/2026"
                      const [year, month, day] = item.request_date.split('-');
                      return `${day}/${month}/${year}`;
                    })();

                    return (
                      <tr key={item.serviceId || index}>
                        <td>{serial}</td>
                        <td>{displayDate}</td>
                        <td>{serviceName}</td>
                        <td>{cost.toFixed(3)} BHD</td>
                        <td>{quantity}</td>
                        <td>{total.toFixed(3)} BHD</td>
                        <td className="text-center">
                          <div
                            style={{
                              cursor:
                                (item.billing_status || "") === "Paid"
                                  ? "not-allowed"
                                  : "pointer",
                              opacity:
                                (item.billing_status || "") === "Paid" ? 0.5 : 1,
                            }}
                            title={
                              (item.billing_status || "") === "Paid"
                                ? "Cannot delete paid lab request"
                                : "Delete"
                            }
                            className="avtar avtar-xs btn-link-secondary deleteIcon"
                            onClick={() =>
                              (item.billing_status || "") === "Paid"
                                ? null
                                : handleDeleteLabRequest(item.parentRequestId)
                            }
                          >
                            <i className="ti ti-trash f-20" />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No lab services found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>


        </div>
      </div>

      {/* Service Modal */}
      {serviceModalOpen && (() => {
        const s = availableServices.find(x => x.id === serviceFormData.serviceId);
        const fld = { fontSize: 12, height: 32, borderRadius: 7, border: '1px solid #dde3eb', padding: '0 10px', width: '100%', background: '#fff', color: '#2d3748', outline: 'none' };
        const lbl = { fontSize: 10, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 3 };
        const col = (flex) => ({ flex, minWidth: 0 });
        return (
          <div style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 900, boxShadow: '0 8px 40px rgba(0,0,0,0.2)', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 20px', borderBottom: '1px solid #e8ecf0' }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: '#4680ff18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <i className="ti ti-stethoscope" style={{ color: '#4680ff', fontSize: 17 }} />
                </div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>
                  {selectedService ? 'Edit Service' : 'Add Service'}
                </div>
                <button type="button" onClick={() => setServiceModalOpen(false)}
                  style={{ marginLeft: 'auto', width: 26, height: 26, borderRadius: 6, border: '1px solid #e8ecf0', background: '#f8f9fb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5B6B79', fontSize: 14 }}>
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleServiceSubmit}>
                <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {/* Row 1: Search */}
                  <div style={{ position: 'relative' }} ref={serviceDropdownRef}>
                    <label style={lbl}>Search & Select Service <span style={{ color: '#e53e3e' }}>*</span></label>
                    <input
                      type="text"
                      style={{ ...fld, height: 34, border: serviceFormData.serviceId ? '1px solid #dde3eb' : '1px solid #f6ad55' }}
                      placeholder="Type to search by name or code..."
                      value={searchServiceQuery}
                      onChange={e => { setSearchServiceQuery(e.target.value); setShowServiceSuggestions(true); }}
                      onFocus={() => setShowServiceSuggestions(true)}
                      required
                    />
                    {!serviceFormData.serviceId && (
                      <div style={{ fontSize: 11, color: '#d97706', marginTop: 3 }}>
                        <i className="ti ti-alert-circle me-1" />Please select a service from the list
                      </div>
                    )}
                    {showServiceSuggestions && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1100, background: '#fff', border: '1px solid #e8ecf0', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: 220, overflowY: 'auto', marginTop: 2 }}>
                        {filteredServices.length === 0
                          ? <div style={{ padding: '10px 14px', fontSize: 12, color: '#9aa0ac' }}>No services found</div>
                          : filteredServices.map(service => (
                            <div key={service.id}
                              onClick={() => {
                                const baseCost = hasActiveInsuranceCard ? service.companyPrice ?? service.insurancePrice ?? service.insurance_price ?? service.standardCost : service.standardCost;
                                setServiceFormData({ ...serviceFormData, serviceId: service.id, customCost: baseCost || '' });
                                setSearchServiceQuery(`${service.code} - ${service.serviceName}`);
                                setShowServiceSuggestions(false);
                              }}
                              style={{ padding: '8px 14px', fontSize: 12, cursor: 'pointer', borderBottom: '1px solid #f0f2f5', background: service.id === serviceFormData.serviceId ? '#4680ff0d' : '#fff', color: service.id === serviceFormData.serviceId ? '#4680ff' : '#2d3748', fontWeight: service.id === serviceFormData.serviceId ? 600 : 400 }}
                              onMouseEnter={e => { if (service.id !== serviceFormData.serviceId) e.currentTarget.style.background = '#f8f9fb'; }}
                              onMouseLeave={e => { if (service.id !== serviceFormData.serviceId) e.currentTarget.style.background = '#fff'; }}
                            >
                              <span style={{ fontWeight: 600 }}>{service.code}</span> — {service.serviceName}
                              <span style={{ marginLeft: 8, fontSize: 11, color: '#5B6B79' }}>
                                {hasActiveInsuranceCard ? `${service.companyPrice ?? service.insurancePrice ?? service.insurance_price ?? service.standardCost} BHD` : `${service.standardCost} BHD`}
                              </span>
                            </div>
                          ))
                        }
                      </div>
                    )}
                  </div>
                  {/* Row 2: Code | Name | Cost | VAT */}
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={col('0 0 120px')}>
                      <label style={lbl}>Code</label>
                      <input style={{ ...fld, background: '#f8f9fb' }} value={s?.code || ''} readOnly />
                    </div>
                    <div style={col(1)}>
                      <label style={lbl}>Service Name</label>
                      <input style={{ ...fld, background: '#f8f9fb' }} value={s?.serviceName || ''} readOnly />
                    </div>
                    <div style={col('0 0 150px')}>
                      <label style={lbl}>{hasActiveInsuranceCard ? 'Insurance Cost' : 'Standard Cost'}</label>
                      <input type="number" style={fld} value={serviceFormData.customCost}
                        onChange={e => setServiceFormData({ ...serviceFormData, customCost: e.target.value })}
                        step="0.001" min="0"
                        placeholder={hasActiveInsuranceCard ? s?.companyPrice ?? s?.insurancePrice ?? s?.insurance_price ?? s?.standardCost : s?.standardCost} />
                    </div>
                    <div style={col('0 0 90px')}>
                      <label style={lbl}>Quantity</label>
                      <input type="number" style={fld} value={serviceFormData.quantity ?? 1}
                        onChange={e => setServiceFormData({ ...serviceFormData, quantity: parseInt(e.target.value, 10) || 1 })}
                        step="1" min="1" />
                    </div>
                    <div style={col('0 0 80px')}>
                      <label style={lbl}>VAT</label>
                      <input style={{ ...fld, background: '#f8f9fb' }} value={s ? (s.vatEnabled ? `${s.vatValue}%` : '0%') : ''} readOnly />
                    </div>
                    <div style={col('0 0 120px')}>
                      <label style={lbl}>Total</label>
                      <input style={{ ...fld, background: '#f8f9fb', fontWeight: 600 }}
                        value={(Number(serviceFormData.customCost || 0) * (Number(serviceFormData.quantity) || 1)).toFixed(3)}
                        readOnly />
                    </div>
                  </div>
                  {/* Row 3: Doctor (add only) | Discount Type | Discount Value */}
                  <div style={{ display: 'flex', gap: 10 }}>
                    {!selectedService && (
                      <div style={col(1)}>
                        <label style={lbl}>Doctor <span style={{ color: '#e53e3e' }}>*</span></label>
                        <select style={{ ...fld, cursor: 'pointer' }} name="sent_by" value={serviceFormData.sent_by || ''}
                          onChange={e => setServiceFormData({ ...serviceFormData, sent_by: e.target.value })} required>
                          <option value="">Select Doctor</option>
                          {enhancedDoctors.map((doc, i) => (
                            <option key={i} value={doc.id}>{doc.displayName || doc.fullName || doc.name}</option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div style={col('0 0 180px')}>
                      <label style={lbl}>Discount Type</label>
                      <select style={{ ...fld, cursor: 'pointer' }} value={serviceFormData.discountType}
                        onChange={e => setServiceFormData({ ...serviceFormData, discountType: e.target.value, discountValue: 0 })}>
                        <option value="Amount">By Amount BHD</option>
                        <option value="Percentage">By Percentage (%)</option>
                      </select>
                    </div>
                    <div style={col('0 0 130px')}>
                      <label style={lbl}>
                        Discount Value
                        {globalDiscountLimit > 0 && (
                          <small className="text-muted ms-1">
                            {serviceFormData.discountType === "Percentage"
                              ? `(Max: ${globalDiscountLimit}%)`
                              : `(Max: ${globalDiscountLimit}% of total)`}
                          </small>
                        )}
                      </label>
                      <input type="number" style={fld} value={serviceFormData.discountValue}
                        onChange={handleDiscountValueChange}
                        min="0" step="0.001" />
                    </div>
                  </div>
                  {/* Row 4: Description | Extra Notes */}
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <label style={lbl}>Description</label>
                      <textarea style={{ ...fld, height: 56, resize: 'none', padding: '6px 10px' }} value={s?.description || ''} readOnly />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <label style={lbl}>Extra Notes</label>
                      <textarea style={{ ...fld, height: 56, resize: 'none', padding: '6px 10px' }}
                        value={serviceFormData.extraNotes}
                        onChange={e => setServiceFormData({ ...serviceFormData, extraNotes: e.target.value })} />
                    </div>
                  </div>

                </div>

                {/* Footer */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 20px', borderTop: '1px solid #f0f2f5' }}>
                  <button type="button" onClick={() => setServiceModalOpen(false)}
                    style={{ padding: '7px 18px', fontSize: 13, borderRadius: 8, border: '1px solid #dde3eb', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer' }}>
                    Cancel
                  </button>
                  <button type="submit" disabled={!serviceFormData.serviceId}
                    title={!serviceFormData.serviceId ? 'Please select a service first' : ''}
                    style={{ padding: '7px 18px', fontSize: 13, borderRadius: 8, border: 'none', cursor: serviceFormData.serviceId ? 'pointer' : 'not-allowed', background: serviceFormData.serviceId ? '#4680ff' : '#c8d0da', color: '#fff', fontWeight: 600 }}>
                    {selectedService ? 'Update' : 'Add'} Service
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
      })()}

      <QuickAddConsentModal
        open={!!pendingMissingConsents}
        onClose={() => setPendingMissingConsents(null)}
        patientId={patientId}
        patient={patientDetailsFromParent}
        missing={pendingMissingConsents || []}
        onDone={() => {
          setPendingMissingConsents(null);
          handleServiceSubmit({ preventDefault: () => { } });
        }}
      />

      {/* Print selection modal */}
      {printModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Services to Print</h5>
                {/* <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setPrintModalOpen(false);
                    setIsSelectingForPrint(false);
                  }}
                ></button> */}
              </div>
              <div className="modal-body billingModal">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h6>Choose services you want on the printout</h6>
                  </div>
                  <button
                    type="button"
                    className="bgBtn btn-sm d-flex align-items-center gap-1"
                    style={{ fontSize: 13, padding: "5px 12px" }}
                    onClick={handleSelectAllServices}
                  >
                    Select / Deselect All
                  </button>
                </div>
                <div className="list-group">
                  {safeServices.length === 0 && (
                    <div className="list-group-item text-muted">
                      No services available
                    </div>
                  )}
                  {safeServices.map((service) => (
                    <label
                      key={service.id}
                      className="list-group-item d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        checked={selectedPrintIds.includes(service.id)}
                        onChange={() => handleServiceSelection(service.id)}
                      />
                      <div className="flex-grow-1">
                        <div>
                          <strong>
                            {service.serviceName ||
                              service.service_name ||
                              service.name ||
                              "Service"}
                          </strong>{" "}
                          <span className="text-muted">
                            {service.serviceCode ||
                              service.service_code ||
                              service.code
                              ? `(${service.serviceCode ||
                              service.service_code ||
                              service.code
                              })`
                              : ""}
                          </span>
                        </div>
                        <div className="small text-muted">
                          Net: {service.netAmount ?? service.net_amount ?? 0}{" "}
                          BHD
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancelText"
                  onClick={() => {
                    setPrintModalOpen(false);
                    setIsSelectingForPrint(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="bgBtn btn-sm d-flex align-items-center gap-1"
                  style={{ fontSize: 13, padding: "5px 12px" }}
                  onClick={handlePrintSelected}
                  disabled={selectedPrintIds.length === 0}
                >
                  Print Selected
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {printModalOpen && <div className="modal-backdrop fade show"></div>}

      {/* Inventory Modal */}
      {inventoryModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedInventory ? "Edit Inventory Item" : "Add Item"}
                </h5>
                {/* <button
                  type="button"
                  className="btn-close"
                  onClick={() => setInventoryModalOpen(false)}
                ></button> */}
              </div>
              <form onSubmit={handleInventorySubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 position-relative">
                      <label className="form-label">
                        Search & Select Inventory
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type to search by name or ID..."
                        value={searchInventoryQuery}
                        onChange={(e) => {
                          setSearchInventoryQuery(e.target.value);
                          setShowInventorySuggestions(true);
                        }}
                        onFocus={() => setShowInventorySuggestions(true)}
                      />
                      {showInventorySuggestions && (
                        <div
                          className="list-group shadow"
                          style={{
                            maxHeight: 240,
                            overflowY: "auto",
                            position: "absolute",
                            width: "100%",
                            zIndex: 1051,
                          }}
                        >
                          {filteredInventory.length === 0 && (
                            // <div className="list-group-item text-muted">No matches</div>
                            <div></div>
                          )}
                          {filteredInventory.map((item) => (
                            <button
                              key={item.id}
                              type="button"
                              className={`list-group-item list-group-item-action ${item.id === inventoryFormData.inventoryId
                                ? "active"
                                : ""
                                }`}
                              onClick={() => {
                                setInventoryFormData({
                                  ...inventoryFormData,
                                  inventoryId: item.id,
                                });
                                setSearchInventoryQuery(
                                  `${item.id} - ${item.name}`
                                );
                                setShowInventorySuggestions(false);
                              }}
                            >
                              {item.id} - {item.name} (BHD{item.price} per unit,
                              Stock: {item.quantity})
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    {/* Auto-filled inventory details */}
                    {(() => {
                      const inv = availableInventory.find(
                        (x) => x.id === inventoryFormData.inventoryId
                      );
                      return (
                        <>
                          <div className="col-md-6">
                            <label className="form-label">Name</label>
                            <input
                              className="form-control"
                              value={inv?.name || ""}
                              readOnly
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Price (per unit)
                            </label>
                            <input
                              className="form-control"
                              value={inv?.price ?? ""}
                              readOnly
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Stock</label>
                            <input
                              className="form-control"
                              value={inv?.quantity ?? ""}
                              readOnly
                            />
                          </div>
                        </>
                      );
                    })()}
                    <div className="col-md-6">
                      <label className="form-label">Quantity</label>
                      <input
                        type="number"
                        className="form-control"
                        value={inventoryFormData.quantity}
                        onChange={(e) =>
                          setInventoryFormData({
                            ...inventoryFormData,
                            quantity: parseInt(e.target.value) || 1,
                          })
                        }
                        min="1"
                        max={
                          availableInventory.find(
                            (x) => x.id === inventoryFormData.inventoryId
                          )?.quantity ?? undefined
                        }
                        required
                      />
                      <div className="form-text">
                        In stock:{" "}
                        {availableInventory.find(
                          (x) => x.id === inventoryFormData.inventoryId
                        )?.quantity ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancelText"
                    onClick={() => setInventoryModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bgBtn btn-sm d-flex align-items-center gap-1"
                    style={{ fontSize: 13, padding: "5px 12px" }}
                  >
                    {selectedInventory ? "Update" : "Add"} Item
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop */}
      {inventoryModalOpen && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
}

// Pagination component
function Pagination({ currentPage, totalPages, setCurrentPage }) {
  return (
    <div className="d-flex align-items-center gap-3">
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        &lt;&lt;
      </button>
      <span>
        {currentPage}/{totalPages}
      </span>
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
        &gt;&gt;
      </button>
    </div>
  );
}
